import script from "./UpdateCommandeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateCommandeForm.vue?vue&type=script&setup=true&lang=js"

import "./UpdateCommandeForm.vue?vue&type=style&index=0&id=6346458a&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6346458a"]])

export default __exports__